import type { createHttpClient } from '@storebrand-digital/bank-foundation-http-service';

import auth from '../../utils/auth';

type HttpClientOptions = Parameters<typeof createHttpClient>[0];

export const httpClientConfig: HttpClientOptions = {
  baseUrl: window.env.API_ROOT,
  clientId: window.env.CLIENT_ID,
  correlationIdProvider: () => crypto.randomUUID(),
  tokenProvider: () => auth.getToken(),
};
